export default __webpack_public_path__ + "static/wordpress_service_features-8eb077448b3c4e323c0cc97ff97e866a.svg";